import React from "react";
import {ReactComponent as Robot} from "../../assets/robot.svg";
import styled from "styled-components";
import {TextGradient} from "../../styles/globalStyles";
import {device} from "../../styles/breakpoints";


const StyledRobot = styled(Robot)`
  margin-bottom: 20px;
  align-self: center;

`;

const Paragraph = styled(TextGradient)`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  padding: 0 5vw;
  @media ${device.tablet} {
    font-size: 60px;
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  justify-items: center;
  @media ${device.tablet} {
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 2fr;
    
  
  }
`;

const RobotSection = () => (
  <Wrapper>
    <StyledRobot/>
    <Paragraph>Make your marketing
      completely based on Artificial Intelligence.</Paragraph>
  </Wrapper>


);
export default RobotSection;
